module.exports = __webpack_public_path__ + "assets/img/wzt.07e2a8a9.png";